module.exports = __webpack_public_path__ + "img/save-info-bg.0ced39a1.png";